import i18n from "@/i18n";
export default class DataReportsPage {
}
DataReportsPage.Breadcrumbs = [
    {
        to: "/",
        text: i18n.t("breadcrumbs.home"),
    },
    {
        to: "/shop/offers",
        exact: true,
        text: i18n.t("breadcrumbs.shop"),
        disabled: true,
    },
    {
        to: "",
        text: "Reports",
        disabled: true,
    },
];
